import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
// import Routes from 'routes';
import { Route, Routes, useNavigate } from 'react-router-dom';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import MainLayout from 'layout/MainLayout';
import AuthRoutes from 'routes/AuthRoutes';
import PageNotFound from 'views/PageNotFound';
import ProtectedRoute from 'utils/ProtectedRoute';
import AdminRoutes from 'routes/AdminRoutes';
import VendorRoutes from 'routes/VendorRoutes';
import AuthLogin3 from 'views/pages/authentication/authentication3/Login3';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SocketProvider } from 'contexts/SocketContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient();

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);
    // const accountType = customization?.userInfo?.accountType;
    const allRoutes = [...VendorRoutes, ...AdminRoutes];
    const authRoutes = AuthRoutes;
    return (
        <QueryClientProvider client={queryClient}>
            <SocketProvider>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={themes(customization)}>
                        <CssBaseline />
                        <NavigationScroll>
                            {/* <MainLayout> */}
                            <Routes>
                                <Route path="/" element={<AuthLogin3 />} />
                                {authRoutes.map((route, key) => (
                                    <Route path={'/' + route?.path} element={route?.element} key={key} />
                                ))}
                                <Route element={<MainLayout />}>
                                    {allRoutes.map((route, key) => {
                                        const routePath = route?.path
                                            ? `/${route.prefix}/${route.path}`
                                            : `/${route.prefix}`;
                                        return (
                                            <Route
                                                path={routePath}
                                                element={<ProtectedRoute prefix={route?.prefix}>{route?.element}</ProtectedRoute>}
                                                key={key}
                                            />
                                        );
                                    })}
                                    <Route path="/user*" element={<div>Page Not FOund</div>} />
                                    <Route path="/admin*" element={<div>Page Not FOund</div>} />
                                    <Route path="/vendor*" element={<div>Page Not FOund</div>} />
                                </Route>
                                <Route path="*" element={<PageNotFound />} />
                            </Routes>
                            {/* </MainLayout> */}
                            {/* <Routes /> */}
                        </NavigationScroll>
                        <ToastContainer />
                    </ThemeProvider>
                </StyledEngineProvider>
            </SocketProvider>
        </QueryClientProvider>
    );
};

export default App;
